
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 3C0 1.34315 1.34315 0 3 0H22C23.6569 0 25 1.34315 25 3V22C25 23.6569 23.6569 25 22 25H3C1.34315 25 0 23.6569 0 22V3Z","fill":"#69C4CD"}}),_c('path',{attrs:{"d":"M17.4998 16.2709C17.4998 19.9733 14.0671 20.8333 11.7305 20.8333C9.39394 20.8333 7.49976 18.7907 7.49976 16.2709C7.49976 13.7512 9.39394 14.1971 11.7305 14.1971C14.0671 14.1971 17.4998 13.7512 17.4998 16.2709Z","fill":"#2C3E50"}}),_c('path',{attrs:{"d":"M4.16789 7.50001C4.16789 9.77478 5.41789 7.91668 7.08455 7.91668C8.75122 7.91668 10.0012 8.85811 10.0012 7.91668C10.0012 6.62801 8.37322 5.83334 7.08455 5.83334C5.79589 5.83334 4.16789 6.21135 4.16789 7.50001Z","fill":"#2C3E50"}}),_c('path',{attrs:{"d":"M20.8333 7.50001C20.8333 9.77478 19.5833 7.91668 17.9166 7.91668C16.2499 7.91668 14.9999 8.85811 14.9999 7.91668C14.9999 6.62801 16.6279 5.83334 17.9166 5.83334C19.2052 5.83334 20.8333 6.21135 20.8333 7.50001Z","fill":"#2C3E50"}})])
          )
        }
      }
    